export default "__VITE_ASSET__CAGF_EQY__"